import * as AppPics from 'assets/images';
import { useHistory, useParams, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import useGetSinglePodcastTicket from 'hooks/API/GET/useGetSinglePodcastTicket';

function ManagePodcastSupportTicket() {
  const { ticketId } = useParams();

  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const redirectBack = params.get('redirect_back');

  const { data: ticket } = useGetSinglePodcastTicket({
    ticketId,
    enabled: true,
  });

  const ticketData = ticket?.data?.data?.ticket;

  const handleGoBack = () => {
    if (redirectBack) {
      history.replace(decodeURIComponent(redirectBack));
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <div className="mainWraper coursetabsection">
        <div className="tab">
          <ul className="tab__menu">
            <li className="back">
              <button className="btn-back" onClick={handleGoBack}>
                <img src={AppPics.BackSvg} alt="Back" />
              </button>
            </li>
          </ul>

          <div className="tab__content ___adjust___tab___padding">
            <div className="tab__content-actHead">
              <AppBreadcrumbs
                links={[
                  { label: 'Dashboard', to: '/dashboard' },
                  { label: 'Podcast Home', to: '/podcast' },
                  { label: 'Support', to: `/support/podcast` },
                ]}
                current="Info"
              />
            </div>

            <div className="tab__content-actBody">
              <div className="px-5 py-5">
                <div className="ticket-view">
                  {/* USER ISSUE */}
                  <div className="row mb-4">
                    <div className="col-12">
                      <h2 className="prime-head p-0 boldtitle">User Issue</h2>
                      <p className="prime-head p-0 boldtitle">
                        Issue Type: {ticketData?.issueCategory}
                      </p>
                      <p className="user-message">Message: {ticketData?.message}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManagePodcastSupportTicket;
